import { getModuleVersionProps } from '../../interfaces/module/getModuleVersionURLProps'
import { IMicrofront, MinimalVersion } from '../../interfaces/MFE/IMicrofront'
import { platform } from '../device/platform'
import { getLocalMfeConfig } from '../../hooks/ModuleFederation/local-mfe-config'

export function getFeatureUrl (
  feat: IMicrofront | undefined,
  microfronts: {
    discovered: IMicrofront[]
    downloaded?: MinimalVersion[]
  }): string {
  if (feat === undefined) return ''

  // In development, check local-mfes.json first
  // localConfig.url already handles platform-aware routing (proxy for mobile, direct for web)
  if (process.env.NODE_ENV === 'development' && feat.mfe_name) {
    const localConfig = getLocalMfeConfig(feat.mfe_name)
    if (localConfig) {
      return localConfig.url
    }
  }

  // Only use localhost for actual mobile platforms, not web
  if (platform !== 'web') {
    const devHost = process.env.LOCAL_IP || 'localhost'

    // Local dev MFE (injected by discovery with "local-" prefix id)
    if (feat.mfe_id?.startsWith('local-')) {
      try {
        const port = new URL(feat.location).port || '8097'
        return `http://${devHost}:8080/mfe-proxy/${port}/remoteEntry.js`
      } catch {
        return `http://${devHost}:8080/mfe-proxy/8097/remoteEntry.js`
      }
    }

    const MOBILE_WEBSERVER_URL = `http://localhost:9001`
    const alreadyDownloaded = microfronts.downloaded?.find(mfe => mfe.mfe_id === feat.mfe_id && mfe.version === feat.version)
    if (alreadyDownloaded != null) {
      return `${MOBILE_WEBSERVER_URL}/modules/${alreadyDownloaded.mfe_id}/${alreadyDownloaded.version}/${feat.data.entry_file}`
    }

    // Fallback: use remote CDN URL when module not found in downloaded array on mobile
    return `${process.env.MFE_SOURCES_URL}/${feat.location}${feat.data.entry_file}`
  }

  // Web platform

  // Local dev MFE (injected by discovery with "local-" prefix id)
  if (feat.mfe_id?.startsWith('local-')) {
    return `${feat.location}remoteEntry.js`
  }

  const url = `${process.env.MFE_SOURCES_URL}/${feat.location}${feat.data.entry_file}`
  return url
}

export function getModuleVersionURL ({ featureId, featureName, microfronts }: getModuleVersionProps): string {
  return getFeatureUrl(getModuleVersion({ featureId, featureName, microfronts }), microfronts)
}

export function getModuleVersion ({ featureId, featureName, microfronts }: getModuleVersionProps): IMicrofront | undefined {
  return microfronts.discovered.find(f => f.mfe_id === featureId || f.mfe_name === featureName)
}
